<template>
    <v-container class="container-view mx-auto">
        <v-row class="d-flex justify-center white--text">
            <h1>PREP</h1>
        </v-row>
        <v-row class="d-flex justify-end" style="margin-bottom:5px">
            <v-btn color="white" text to="prep/planillas">
                Ver planillas
            </v-btn>
        </v-row>
        <v-row class="d-flex justify-center">
            <table class="table-filters" width="100%">
                <tbody>
                    <tr>
                        <td width="20%">
                            Elecciones
                        </td>
                        <td width="80%">
                            <v-select
                                v-model="electionIdSelected"
                                :item-text="textItemElection"
                                :items="elecciones"
                                :loading="loading"
                                item-value="id"
                                label="Selecciona elección"
                                @change="onChangeElection"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Centros / SEMS
                        </td>
                        <td>
                            <v-select
                                v-model="centerSelected"
                                :disabled="centers.length === 0"
                                :item-text="textItemCenter"
                                :items="centers"
                                :loading="loading"
                                item-value="centro"
                                label="Selecciona centro / SEMS"
                                @change="onChangeCenter"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Divisiones / Escuelas
                        </td>
                        <td>
                            <v-autocomplete
                                v-model="uresSelected"
                                :disabled="uresList.length === 0"
                                :item-text="textItemUres"
                                :items="uresList"
                                :loading="loading"
                                item-value="ures_pred"
                                label="Selecciona División / Escuela"
                                @change="onChangeUres"
                            >
                            </v-autocomplete>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Mesas
                        </td>
                        <td>
                            <v-select
                                v-model="tableSelected"
                                :disabled="tables.length === 0"
                                :items="tables"
                                :loading="loading"
                                chips
                                item-text="mesa"
                                item-value="mesa"
                                multiple
                                persistent-hint
                                @change="onChangeTable"
                            >
                            </v-select>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <v-btn
                                :disabled="
                                    !electionIdSelected || downloadingCSV
                                "
                                elevation="2"
                                small
                                style="pading: 10px 0px;"
                                @click="downloadCSV"
                                >Descargar Votos
                            </v-btn>
                            <br />
                            <small
                                >Descargar todos los votos de la elección
                                (CSV)</small
                            >
                            <scale-loader
                                v-if="downloadingCSV"
                                class="prp-chart-loader"
                                color="black"
                            ></scale-loader>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="table-mesas">
                <v-row class="d-flex justify-center white--text py-5">
                    <h3>Detalle de votos por mesa</h3>
                    <v-btn
                        v-if="electionIdSelected"
                        :disabled="loading"
                        class="ml-5 white--text"
                        color="blue lighten-1"
                        elevation="2"
                        small
                        style="pading: 10px 0px;"
                        @click="onChangeUres"
                    >
                        <i class="fas far fa fa-sync"></i>
                    </v-btn>
                    <br />
                </v-row>
                <v-data-table :headers="headersTables" :items="tableList">
                    <template v-slot:item.votes="{ item }">
                        <v-chip-group column>
                            <v-tooltip
                                v-for="(vote, index) in item.votes"
                                :key="index"
                                top
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip
                                        :color="'#' + vote.hexa_color"
                                        :text-color="
                                            textColorChip(vote.hexa_color)
                                        "
                                        v-bind="attrs"
                                        @click="showCandidates(vote)"
                                        v-on="on"
                                    >
                                        {{ vote.count }}
                                    </v-chip>
                                </template>
                                <span class="tooltip-text"
                                    >ID PLANILLA: {{ vote.id_planilla }}</span
                                >
                            </v-tooltip>
                        </v-chip-group>
                    </template>
                    <template slot="body.append">
                        <tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>{{ tableListTotal }}</th>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <div class="prp-chart-container">
                <scale-loader
                    v-if="loading"
                    class="prp-chart-loader"
                    color="black"
                ></scale-loader>
                <apexchart
                    v-else
                    :options="chartOptions"
                    :series="series"
                    height="250"
                    type="bar"
                    width="100%"
                ></apexchart>
            </div>
        </v-row>
        <v-dialog v-model="dialog" max-width="350" scrollable>
            <v-card class="dialog-candidates">
                <v-card-title class="headline">
                    Representantes de planilla
                    <h4
                        :style="{
                            color: textColorCard(candidates.hexa_color),
                        }"
                    >
                        {{ candidates.color }} {{ candidates.id_planilla }}
                    </h4>
                </v-card-title>
                <v-card-text class="content">
                    <scale-loader
                        v-if="candidates.loading"
                        color="black"
                    ></scale-loader>
                    <div
                        v-for="(candidate, index) in candidates.data"
                        :key="'candidate-' + index"
                        class="candidate-container"
                    >
                        <h3 class="candidate-title">
                            {{ candidate.nombre }}
                        </h3>
                        <span
                            :style="{
                                color: textColorCard(candidates.hexa_color),
                            }"
                            class="candidate-subtitle"
                            >{{ candidate.clase_funcionario }}
                            {{ candidate.no_integrante }}</span
                        >
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" text @click="dialog = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
import FileDownload from 'js-file-download';
import moment from 'moment-timezone';

export default {
    name: 'prep',
    components: {
        apexchart: VueApexCharts,
        ScaleLoader,
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    data: () => {
        return {
            dataResul: {
                cgu: {
                    votos: [
                        {
                            name: 'AMARILLO',
                            total: 796,
                        },
                        {
                            name: 'AZUL',
                            total: 264,
                        },
                        {
                            name: 'MORADO',
                            total: 494,
                        },
                        {
                            name: 'NARANJA',
                            total: 589,
                        },
                        {
                            name: 'NULO',
                            total: 224,
                        },
                        {
                            name: 'ROJO',
                            total: 460,
                        },
                        {
                            name: 'VERDE',
                            total: 782,
                        },
                    ],
                    participacion: {
                        padron: '16113',
                        totalparticipacion: 3609,
                        porcentajeparticipacion: 22.4,
                    },
                    winner: {
                        name: 'AMARILLO',
                        total: 796,
                    },
                },
            },
            loading: false,
            downloadingCSV: false,
            dialog: false,
            series: [],
            uresList: [],
            centers: [],
            tables: [],
            electionIdSelected: '',
            centerSelected: '',
            uresSelected: '',
            tableSelected: [],
            tableList: [],
            tableListTotal: 0,
            candidates: {
                loading: false,
                color: '',
                id_planilla: '',
                hexa_color: '#002145',
                data: [],
            },
            headersTables: [
                { text: 'Mesa', value: 'mesa_id' },
                { text: 'Nº Mesa', value: 'no_mesa' },
                { text: 'Ures', value: 'ures_ent' },
                {
                    text: 'Votos por Planillas',
                    value: 'votes',
                    unsertable: false,
                },
                { text: 'OCG', value: 'ocg' },
                { text: 'Total', value: 'total' },
            ],
            chartOptions: {
                chart: {
                    height: 300,
                    type: 'bar',
                    events: {
                        click: function(chart, w, e) {
                            console.log(chart, w, e);
                        },
                    },
                },
                colors: [],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    // offsetY: -20,
                    style: {
                        fontSize: '15px',
                        colors: ['#304758'],
                    },
                },
                legend: {
                    // show: false,
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            // colors: colors,
                            fontSize: '12px',
                        },
                    },
                },
            },
        };
    },
    methods: {
        onChangeElection: function() {
            this.uresList = [];
            this.uresSelected = '';
            if (this.electionIdSelected) {
                this.loadCenters();
                this.loadUres();
                this.loadTables();
                this.generateChart();
            }
        },
        onChangeCenter: function() {
            this.uresList = [];
            this.uresSelected = '';
            this.loadUres();
            this.loadTables();
            this.generateChart();
        },
        onChangeUres: function() {
            if (!this.electionIdSelected) {
                return;
            }
            this.loadTables();
            this.generateChart();
        },
        onChangeTable: function() {
            this.generateChart();
        },
        generateChart: function() {
            const filters = {
                election_id: this.electionIdSelected,
                center_id: this.centerSelected,
                ures: this.uresSelected,
                table_id: this.tableSelected == '' ? [] : this.tableSelected,
            };
            this.loading = true;
            this.$store
                .dispatch('prep/getData', filters)
                .then(res => {
                    this.series = res.series;
                    this.chartOptions.colors = res.hexa_colors;
                    this.chartOptions.xaxis.categories = res.ocgs;
                    this.tableList = res.tables;
                    this.tableListTotal = res.total;

                    console.log({ chartData: res });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadCenters: function() {
            this.$store
                .dispatch('prep/getCenters', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    console.log({ centers: res });
                    if (res.length) {
                        res.unshift({
                            centro: '',
                            desc_centro: 'TODOS LOS CENTROS',
                        });
                    }
                    this.centers = res;
                });
        },
        loadUres: function() {
            this.$store
                .dispatch('prep/getUresByIdElection', {
                    election_id: this.electionIdSelected,
                    center_id: this.centerSelected,
                })
                .then(res => {
                    console.log({ ures: res });
                    if (res.length) {
                        res.unshift({
                            ures_pred: '',
                            desc_ures_pred: 'TODOS LOS URES',
                        });
                    }
                    this.uresList = res;
                });
        },
        loadTables: function() {
            this.tables = [];
            this.tableSelected = [];
            this.$store
                .dispatch('prep/getTables', {
                    election_id: this.electionIdSelected,
                    center_id: this.centerSelected,
                    ures: this.uresSelected,
                })
                .then(res => {
                    if (res.length) {
                        this.tables = res.sort((a, b) => {
                            return a.mesa - b.mesa;
                        });
                    }
                });
        },
        downloadCSV: function() {
            this.downloadingCSV = true;
            this.$store
                .dispatch('prep/getVotesCSV', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    const eleccion = this.elecciones.find(
                        eleccion => eleccion.id === this.electionIdSelected
                    );
                    if (eleccion) {
                        const type =
                            eleccion.type.charAt(0).toUpperCase() +
                            eleccion.type.slice(1);
                        const fileName = `${
                            this.electionIdSelected
                        }Votos${type}-${moment().format('DD-MM-YYYY')}`;
                        const data = new Blob([res.csv], { type: 'text/csv' });
                        FileDownload(data, fileName + '.csv');
                    }
                })
                .finally(() => {
                    this.downloadingCSV = false;
                });
        },
        textItemElection: item =>
            `${item.id} - ${item.description} | ${item.type.toUpperCase()}`,
        textItemCenter: item =>
            item.desc_centro + (item.centro ? ' | ' + item.centro : ''),
        textItemUres: item =>
            item.desc_ures_pred +
            (item.ures_pred ? ' | ' + item.ures_pred : ''),
        textColorChip: color => {
            let colorText = 'FFFFFF';
            switch (color) {
                case 'FFFF00':
                case 'DADADA':
                    colorText = '002145';
                    break;
            }
            return '#' + colorText;
        },
        textColorCard: color => {
            switch (color) {
                case 'FFFF00':
                    color = 'F8F32B';
                    break;
            }
            return '#' + color;
        },
        showCandidates: function(vote) {
            if (vote.id_planilla) {
                this.candidates.loading = true;
                this.candidates.data = [];
                this.candidates = { ...this.candidates, ...vote };
                this.$store
                    .dispatch('prep/getCandidates', {
                        id_planilla: vote.id_planilla,
                    })
                    .then(res => {
                        console.log('prep/getCandidates', res);
                        if (res.length) {
                            this.candidates.data = res;
                        }
                    })
                    .finally(() => {
                        this.candidates.loading = false;
                    });
                this.dialog = true;
            }
        },
    },
    created() {
        this.$store.dispatch('elecciones/getElecciones');
    },
};
</script>

<style lang="scss">
.container-view {
    margin-bottom: 55px;
}

.prp-container {
    padding: 1rem;
}

.prp-title {
    text-align: center;
    margin-bottom: 2rem;
}

.prp-home-back {
    cursor: pointer;
    position: absolute;
}

.prp-chart-container {
    position: relative;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    padding: 1rem;
    width: 100%;
    height: calc(250px + 2rem);
    background-color: $votex-gray-background;
}

.prp-chart-loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.table-filters {
    background-color: #fff;
    border-collapse: collapse;
    padding: 1rem;
    border-radius: 0.5rem;

    tr:first-child td {
        border-top: 0;
    }

    tr td:first-child {
        border-left: 0;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    tr td:last-child {
        border-right: 0;
    }

    td {
        border: 1px solid $votex-gray-background;
        color: $votex-background-primary;

        select {
            width: 100%;
        }
    }
}

.table-mesas {
    width: 100%;
    margin-top: 1.5rem;

    .tooltip-text {
        font-size: 12px;
    }
}

.dialog-candidates {
    .headline {
        justify-content: center;

        h4 {
            width: 100%;
        }
    }

    .content {
        text-align: left;
    }

    .candidate-container {
        margin-bottom: 10px;
    }

    .candidate-title {
        color: $votex-background-primary;
    }
}
</style>
